import {Chip} from '@mui/material';
import React, {FC} from 'react';

interface ValueChipProps {
  value: string;
  variant?: 'default' | 'success' | 'error' | 'warning';
  strikethrough?: boolean;
}

/**
 * Composant pour afficher une valeur sous forme de chip
 */
export const ValueChip: FC<ValueChipProps> = ({value, variant = 'default', strikethrough = false}) => {
  const getChipProps = () => {
    switch (variant) {
      case 'success':
        return {color: 'success' as const, variant: 'filled' as const};
      case 'error':
        return {color: 'error' as const, variant: 'outlined' as const};
      case 'warning':
        return {
          variant: 'filled' as const,
          sx: {textDecoration: 'line-through', backgroundColor: '#fecaca', color: '#dc2626'},
        };
      default:
        return {variant: 'outlined' as const};
    }
  };

  return (
    <Chip
      label={value}
      size="small"
      {...getChipProps()}
      sx={{
        ...getChipProps().sx,
        ...(strikethrough ? {textDecoration: 'line-through'} : {}),
      }}
    />
  );
};
